import { render, staticRenderFns } from "./lp-portfolio-performance-2.vue?vue&type=template&id=94148286&scoped=true"
import script from "./lp-portfolio-performance-2.vue?vue&type=script&lang=js"
export * from "./lp-portfolio-performance-2.vue?vue&type=script&lang=js"
import style0 from "./lp-portfolio-performance-2.vue?vue&type=style&index=0&id=94148286&prod&scoped=true&lang=css"
import style1 from "./lp-portfolio-performance-2.vue?vue&type=style&index=1&id=94148286&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94148286",
  null
  
)

export default component.exports